// @flow

import React from 'react';
import styled from 'styled-components';
import type { Theme } from '../../../types';
import Filter from './atoms';

const FilterList = styled<any, Theme>('div')`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 0.5rem;
`;

type Props = {
  filters: Array<{
    id: string,
    value: string,
    type: string,
  }>,
  className?: string, // eslint-disable-line react/require-default-props
  onDelete: (id: string, type: string, value: string) => void,
};

const ActiveFilters = ({
  onDelete,
  filters,
  className,
}: Props) => (
  <FilterList className={className}>
    {filters.map(({ id, value, type }, index) => (
      <Filter
        tabIndex={index}
        id={id}
        key={value}
        value={value}
        onDelete={() => {
          onDelete(id, type, value);
        }}
      />
    ))}
  </FilterList>
);

export default ActiveFilters;
